<h4 class="bold">{{pageTitle()}}</h4>

<div class="row">
    <i *ngIf="_isLoading" class="fa fa-circle-o-notch fa-spin" style="font-size:38px; color: #337ab7;"></i>
</div>

<div class="flex-container background-transparent" style="width: 100%;">
    <div class="flex-item">
        <button *ngIf="canShowBack()" type="button" class="btn btn-sm btn-primary" style="font-size: 14px;" (click)="onBack()">Back</button>
    </div>
    <div class="flex-item">
        <button *ngIf="!_data.inSubEditor" type="button" class="btn btn-sm btn-primary"  style="font-size: 14px;" (click)="onAddMonographFile()">Add Monograph File</button>
    </div>
    <div class="flex-item">
        <button *ngIf="canConfirmRemove" type="button" class="btn btn-sm btn-primary"  style="font-size: 14px;" (click)="onConfirmRemove()">Confirm Remove</button>
    </div>
    <div class="flex-item">
        <button *ngIf="canSave" type="button" class="btn btn-sm btn-primary" style="font-size: 14px;" (click)="onSave()">Save File Changes</button>
    </div>
    <div class="flex-item">
        <button *ngIf="canCancel" type="button" class="btn btn-sm btn-primary" style="font-size: 14px;" (click)="onCancel()">Cancel</button>
    </div>
</div>

<p class="alert-warning bold">{{_validationMessage}}</p>

<div *ngIf="!_data.inSubEditor">
    <div [attr.data-hidden]="!hasFileData()" style="width: 1072px; margin-left: 18px;">
        <div>
            <div class="scrollableTableHeader">
                <div class="scrollableTableColumn text-center"><span class="inline" style="width: 90px">Remove</span></div>
                <div class="scrollableTableColumn text-center"><span class="inline" style="width: 310px">File Label</span></div>
                <div class="scrollableTableColumn text-center"><span class="inline" style="width: 210px">File Name</span></div>
                <div class="scrollableTableColumn text-center"><span class="inline" style="width: 180px">File Type</span></div>
            </div>
            <div style="height: 320px; width: 890px; overflow-y:auto;overflow-x: hidden;">
                <div class="scrollableTableRow" *ngFor="let mf of _materialFilesEx" [ngStyle]="{ 'background-color': mf.backgroundColor }">
                    <div *ngIf="canShowRemove(mf.data)" class="scrollableTableColumn text-center"><a class="inline" style="width: 90px" (click)="onRemove(mf.data)">Remove</a></div>
                    <div *ngIf="!canShowRemove(mf.data)" class="scrollableTableColumn text-center"><span class="inline" style="width: 90px"></span></div>
                    <div class="scrollableTableColumn text-center"><span class="inline" style="width: 310px">{{mf.data.fileLabel}}</span></div>
                    <div class="scrollableTableColumn text-center"><span class="inline" style="width: 210px">{{mf.data.fileName}}</span></div>
                    <div class="scrollableTableColumn text-center"><span class="inline" style="width: 180px">{{mf.data.materialFileType()}}</span></div>
                </div>
            </div>
        </div>
    </div>
</div>

<div *ngIf="_data.inSubEditor">
    <material-file-editor></material-file-editor>
</div>


